import {
  GESTION_OPERATIVA_GET_PRESUPUESTO_BEGIN,
  GESTION_OPERATIVA_GET_PRESUPUESTO_SUCCESS,
  GESTION_OPERATIVA_GET_PRESUPUESTO_FAILURE,
  GESTION_OPERATIVA_GET_PRESUPUESTO_DISMISS_ERROR,
} from './constants'
import { BFFAgent } from '../../../common/BFFAgent'
import { cloneDeep } from 'lodash'

export function getPresupuesto(id, queryData, perfil) {
  console.log('THIS IS THE QUERY DATA FROM HISTORY', queryData)
  return (dispatch) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: GESTION_OPERATIVA_GET_PRESUPUESTO_BEGIN,
    })

    const promise = new Promise((resolve, reject) => {
      const doRequest = BFFAgent.Presupuestador.getPresupuesto(id, queryData, perfil)
      doRequest.then(
        (presupuesto) => {
          dispatch({
            type: GESTION_OPERATIVA_GET_PRESUPUESTO_SUCCESS,
            data: presupuesto,
          })
          resolve(presupuesto)
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: GESTION_OPERATIVA_GET_PRESUPUESTO_FAILURE,
            data: { error: err },
          })
          reject(err)
        },
      )
    })

    return promise
  }
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetPresupuestoError() {
  return {
    type: GESTION_OPERATIVA_GET_PRESUPUESTO_DISMISS_ERROR,
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case GESTION_OPERATIVA_GET_PRESUPUESTO_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getPresupuestoPending: true,
        getPresupuestoError: null,
        presupuesto: null,
        saveButtonDisabled: true,
      }

    case GESTION_OPERATIVA_GET_PRESUPUESTO_SUCCESS:
      // The request is success
      return {
        ...state,
        getPresupuestoPending: false,
        getPresupuestoError: null,
        presupuesto: action.data,
        // clonar data
        client_id: cloneDeep(action.data.client_id),
        catalog_id: cloneDeep(action.data.catalog_id),
        stock_id: cloneDeep(action.data.stock_id),
        cliente: cloneDeep(action.data.cliente),        
        sale: {
          ...state.sale,
          auto: cloneDeep(action.data.auto),
          Taking_cars: cloneDeep(action.data.Taking_cars),          
        },
        saveButtonDisabled: true,
      }

    case GESTION_OPERATIVA_GET_PRESUPUESTO_FAILURE:
      // The request is failed
      return {
        ...state,
        getPresupuestoPending: false,
        getPresupuestoError: action.data.error,
        presupuesto: null,
      }

    case GESTION_OPERATIVA_GET_PRESUPUESTO_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getPresupuestoError: null,
      }

    default:
      return state
  }
}
